var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"brand-name"},[_vm._v("电桩品牌："),_c('span',{staticStyle:{"color":"#409eff"}},[_vm._v(_vm._s(this.$route.query.brandName))])]),_vm._v(" "),_c('STable',{ref:"tableref",attrs:{"url":_vm.url,"columns":_vm.columns,"query":_vm.query,"toolbar":_vm.toolbar,"selection":false,"label-width":"100px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dca68b90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/pileFaultList.vue
// module id = null
// module chunks = 